import { AxiosRequestConfig } from 'axios';
import { apiClient } from '../clients/api';

export interface IGet extends AxiosRequestConfig {
	endpoint?: string;
}

export const getApi = async <TResponse>({ endpoint = '', ...res }: IGet): Promise<TResponse> => {
	const { data } = await apiClient<TResponse>(endpoint, { ...res, method: 'GET' });
	return data;
};
